import { isSelfServiceVideoCommunicationsEnabled } from './isEnabled'

export default isSelfServiceVideoCommunicationsEnabled
